/**
 * Determines whether the current URL
 * has authentication redirect query
 * parameters.
 */
export const hasAuthQueryParams = (): boolean => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  return params.has('code');
};
